import React, { useRef, useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const EllipsisTooltip = ({ children, sx = {}, ...props}) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <Tooltip
      title={children}
      arrow
      disableHoverListener={!isTruncated}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -20], // optional spacing
            },
          },
        ],
      }}
      {...props}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Typography
          ref={textRef}
          noWrap
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            ...sx
          }}
        >
          {children}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default EllipsisTooltip;
